import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import StateAnalysisForm from "./StateAnalysisForm";
import { useDispatch } from "react-redux";
import { uiInfoActions } from "../../../actions";

const StateAnalysis = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const quarters = useSelector((state) => state.publishedQuarter.data);
  const states = useSelector((state) => state.states.data);

  useEffect(() => {
    dispatch(uiInfoActions.publishedQuarter());
    dispatch(uiInfoActions.state());
  }, []);

  if (states && quarters) {
    return (
      <StateAnalysisForm quarters={quarters} states={states} token={token} />
    );
  } else {
    return <></>;
  }
};

export default StateAnalysis;
